<template>
  <button class="c-button" :disabled="disabled" @click="$emit('signup')">
    <span v-if="state === 'loading'">Laden...</span>
    <span v-else-if="state === 'error'">Er is een fout opgetreden</span>
    <span v-else>{{ copy }}</span>
  </button>
</template>

<script>
export default {
  name: "SignUpButton",
  props: {
    copy: String,
    disabled: Boolean,
    state: {
      type: String,
      default: 'idle',
    },
  },
}
</script>
